import { render, staticRenderFns } from "./DashboardSecretaire.vue?vue&type=template&id=6d1820b7&"
import script from "./DashboardSecretaire.vue?vue&type=script&lang=js&"
export * from "./DashboardSecretaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports